module.exports = {
    ENTITY_TYPES: ["INTERNATIONAL", "EUROPE", "NATIONAL", "REGIONAL", "LOCAL", "OWN"],
    DEFAULT_TYPE: "LOCAL",
}